<template>
  <div :key="resume.id"
       @click="onRowClick"
       class="moderator-candidate-resumes__table-row">
    <div class="moderator-candidate-resumes__table-cell  _id  d-md-none">
      <div :to="{name: 'account-moderator-candidates-resume', params: {resumeId: resume.id}}"
           style="color: inherit">
        <span style="color: #506c85">{{ $tModeratorCandidates('Id:') }}</span> {{ resume.id }}
      </div>
    </div>
    <div class="moderator-candidate-resumes__table-cell">
      <div style="margin-bottom: 0.8rem; display: flex; justify-content: space-between">
        <div :to="{name: 'account-moderator-candidates-resume', params: {resumeId: resume.id}}"
             style="color: inherit">
          <span style="color: #506c85">{{ $tModeratorCandidates('User Id:') }}</span> {{ resume.customer.id }}
        </div>
        <div :to="{name: 'account-moderator-candidates-resume', params: {resumeId: resume.id}}"
             style="color: inherit"
             class="d-none  d-md-block">
          <span style="color: #506c85">{{ $tModeratorCandidates('Resume Id:') }}</span> {{ resume.id }}
        </div>
      </div>
      <div>
        <div :to="{name: 'account-moderator-candidates-resume', params: {resumeId: resume.id}}"
             style="font-weight: 500; color: inherit">
          {{ resume.customer.firstname || '-' }} {{ resume.customer.lastname || '-' }}
        </div>
      </div>
      <div v-if="resume.customer.phone"
           style="margin-top: 0.4rem">{{ formatPhone(resume.customer.phone) }}
      </div>
      <div v-if="resume.customer.email"
           style="margin-top: 0.4rem">{{ resume.customer.email }}
      </div>
      <div v-if="resume.customer.last_log"
           style="margin-top: 1.2rem;"
           class="">
        <div style="opacity: 0.7;">{{ resume.customer.last_log.datetime }}</div>
        <div v-html="resume.customer.last_log.action"
             style="margin-top: 0.2rem"></div>
      </div>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _status">
      <div class="moderator-candidate-resumes__table-cell-title">{{ $tModeratorCandidates('Status') }}</div>
      <span>{{ resume.status }}</span>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _uploaded-passport">
      <div class="moderator-candidate-resumes__table-cell-title">
        {{ $tModeratorCandidates('Are all passport spreads loaded?') }}
      </div>
      <span v-if="resume.all_passport_pages" style="color: #16C15B">{{ $tModeratorCandidates('Yes') }}</span>
      <span v-else style="color: #F7AC29">{{ $tModeratorCandidates('No') }}</span>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _moderated-passport">
      <div class="moderator-candidate-resumes__table-cell-title">
        {{ $tModeratorCandidates('Has your passport been checked?') }}
      </div>
      <span v-if="resume.checked_passport" style="color: #16C15B">{{ $tModeratorCandidates('Yes') }}</span>
      <span v-else style="color: #F7AC29">{{ $tModeratorCandidates('No') }}</span>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _have-responds">
      <div class="moderator-candidate-resumes__table-cell-title">
        {{ $tModeratorCandidates('Are there any responses?') }}
      </div>
      <span v-if="resume.have_sent" style="color: #16C15B">{{ $tModeratorCandidates('Yes') }}</span>
      <span v-else style="color: #F7AC29">{{ $tModeratorCandidates('No') }}</span>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _filled-resume">
      <div class="moderator-candidate-resumes__table-cell-title">
        {{ $tModeratorCandidates('Application completion status') }}
      </div>
      <span v-if="resume.questionnaire_status === 0"
            style="color: #727272">{{ $tModeratorCandidates('Not completed') }}</span>
      <span v-else-if="resume.questionnaire_status === 1"
            style="color: #b69e72">{{ $tModeratorCandidates('Started filling') }}</span>
      <span v-else-if="resume.questionnaire_status === 2"
            style="color: #F7AC29">{{ $tModeratorCandidates('There is a completed application form for at least one vacancy') }}</span>
      <span v-else-if="resume.questionnaire_status === 3"
            style="color: #16C15B">{{ $tModeratorCandidates('There are completed questionnaires for all vacancies') }}</span>
      <span v-else-if="resume.questionnaire_status === 4"
            style="color: #16C15B">{{ $tModeratorCandidates('On reboot') }}</span>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _have-interaction">
      <div class="moderator-candidate-resumes__table-cell-title">{{ $tModeratorCandidates('On interaction') }}</div>
      <span v-if="resume.have_interaction" style="color: #16C15B">{{ $tModeratorCandidates('Yes') }}</span>
      <span v-else style="color: #F7AC29">{{ $tModeratorCandidates('No') }}</span>
    </div>
    <div class="moderator-candidate-resumes__table-cell  _toggle">
      <router-link-modified :to="{name: 'account-moderator-candidates-resume', params: {resumeId: resume.id}}"
                            class="moderator-candidate-resumes__table-got-to">
        <BaseSvg name="ico-arrow-light"
                 width="1rem"
                 height="1rem"/>
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  import formatPhone from '@/helpers/formatPhone'

  export default {
    name: 'AMCandidatesResumesPageResumeItem',
    props: {
      resume: Object
    },
    data() {
      return {}
    },
    computed: {
      isOpen() {
        return this.resume.id === parseFloat(this.$route.query['current-resume'] || '')
      },
      route() {
        const query = {...this.$route.query}

        if (this.isOpen) {
          delete query['current-resume']
          return {
            query
          }
        } else {
          query['current-resume'] = this.resume.id
          return {
            query
          }
        }
      }
    },
    methods: {
      formatPhone,

      onRowClick(e) {
        const target = e.target
        if (target.closest('a, button')) return

        e.preventDefault()

        this.$router.push(this.route).catch(() => ({}))
      }
    }
  }
</script>

<style lang="less">

</style>
